import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Drawer from "../Drawer";
import IconView from "../IconView/IconView";
import ImageData from "../customImage/ImageSegment";
import ImageView from "../ImageView/ImageView";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import _ from "lodash";
import { getImageUrl } from "Common/utils/ImageDomain";
import ReactSelect from "../ReactSelect/ReactSelect";
import descriptionStyle from "../../../constants/descriptionStyle.json";
import Button from "../ButtonComponent/Button";
import AwardSegmentCard from "../AwardSegmentCard";
import CustomInput from "../InputFields/CustomInput";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import { showNotification } from "Common/utils/Notification";
/* 
{
  "header_text": "",
  "subheader_text": "",
  "view_url": "",
  "segments": [{ icon: "", description: "" }]
}
*/

const AwardSegment = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentId,
  segmentType,
  toggleVisiblity,
}) => {
  const segment = data?.segments ? data?.segments : [];
  const [segments, setSegments] = useState(segment);
  const [styleType, setStyleType] = useState("");
  const [saticStyle, setStaticStyle] = useState<any>();
  const [headerText, setHeaderText] = useState(
    data?.header_text ? data?.header_text : ""
  );
  const [imageUrl, setImageUrl] = useState(
    data?.background_image ? data?.background_image : ""
  );
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>(
    data?.mobile_background_image_id
  );
  const [imageId, setImageId] = useState("");
  const [indexBack, setIndexBack] = useState("");
  const [subHeaderText, setSubHeaderText] = useState(data?.subheader_text);
  const [eventData, setEventData] = useState<any>();
  const [showVideo, setShowVideo] = useState(false);
  const [index, setIndex] = useState(undefined);
  const [isLoading, setIsLoading] = useState<any>(false);

  const [errors, setErrors] = useState<any>({
    segments: segments?.map(() => ({ icon: "", description: "" })),
  });

  const toggle = () => setShowVideo(!showVideo);
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "image") {
        if (indexBack === undefined) {
          setImageUrl(imageData.media_url);
          setImageId(imageData._id);
          setErrors((prev) => ({ ...prev, ["background_image"]: "" }));
        } else if (indexBack === "background") {
          setMobileBackground(imageData.media_url);
          setMobileBackgroundId(imageData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [imageData, indexBack]);

  useEffect(() => {
    if (data && data?.style) {
      setStaticStyle({ label: data?.style, value: data?.style });
      setStyleType(data?.style);
    }
  }, [data]);

  useEffect(() => {
    if (eventData && eventData.icon_url) {
      handleSegmentInputChange(index, "icon", eventData.icon_url);
      handleSegmentInputChange(index, "icon_id", eventData._id);
    }
  }, [eventData, index]);

  const addSegment = () => {
    setSegments([...segments, { icon: "", description: "" }]);
    setErrors({
      ...errors,
      segments: [...errors.segments, { icon: "", description: "" }],
    });
  };

  const removeSegment = (index) => {
    const updatedSegments = segments.filter((_, i) => i !== index);
    setSegments(updatedSegments);

    const updatedErrors = { ...errors };
    updatedErrors.segments.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleStyleData = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
      setStyleType("");
    } else {
      setStyleType(keyValue.value);
    }
    setStaticStyle(keyValue);
  };

  const handleSegmentInputChange = (index, field, value) => {
    const updatedButtons = segments.map((button, i) => {
      if (i === index) {
        button[field] = value;
      }
      return button;
    });
    setSegments(updatedButtons);

    const updatedErrors = { ...errors };
    if (updatedErrors.segments[index]) {
      updatedErrors.segments[index][field] = "";
    }
    setErrors(updatedErrors);
  };

  const handleRemoveIcon = (index) => {
    setSegments((prevSegments) =>
      prevSegments.map((segment, i) =>
        i === index ? { ...segment, icon: "" } : segment
      )
    );
  };

  const handleSave = async (pageId, id) => {
    const newErrors = {
      segments: segments?.map(() => ({ icon: "", description: "" })),
      background_image_id: imageId,
      background_image: imageUrl,
    };

    segments?.forEach((award, index) => {
      if (!award.icon?.trim()) {
        newErrors.segments[index].icon = "Icon is required.";
      }
      if (!award.description?.trim()) {
        newErrors.segments[index].description = "Description is required.";
      }
    });

    setErrors(newErrors);

    if (
      newErrors?.segments?.every((error) => !error.icon && !error.description)
    ) {
      const payload = {
        segment_type: "award_segments",
        header_text: headerText,
        subheader_text: subHeaderText,
        style: styleType,
        segments,

        background_image: (imageUrl === null || imageUrl == undefined) ? "" : imageUrl,
      background_image_id: (imageUrl === null || imageUrl == undefined) ? "" : imageId,
      mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground,
      mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
      };

      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Award Segment saved successfully!", "success");
        }
      } catch (e) {
        showNotification(
          "An error occurred while saving the award segment. Please try again.",
          "error"
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        {/* Header Text */}
        <div className="xl:col-span-12">
          <CustomInput
            label=" Header Text"
            name="headerText"
            type="text"
            placeholder="Enter Header Text"
            value={headerText}
            onChange={(e) => setHeaderText(e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.header_text}
          />
        </div>

        {/* Sub Header Text */}
        <div className="mt-4 xl:col-span-12">
          <CustomInput
            label=" Sub Header Text"
            name="subheaderText"
            type="text"
            placeholder="Enter Subheader Text"
            value={subHeaderText}
            onChange={(e) => setSubHeaderText(e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.subheader_text}
          />
        </div>
        <div>
          <div className="flex my-4">
            {imageUrl ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={imageUrl}
                  setImageData={setImageData}
                  setImageLink={setImageUrl}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack(undefined);
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack(undefined);
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add imageUrl
              </button>
            )}
          </div>
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setImageData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack("background");
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack("background");
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add Mobile Background
              </button>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="mb-4 xl:col-span-6">
            <label className="inline-block mb-2 text-base font-medium">
              Style
            </label>
            <ReactSelect
              versionData={
                versionData
                  ? { label: versionData?.style, value: versionData?.style }
                  : null
              }
              options={descriptionStyle}
              isSearchable={false}
              isMulti={false}
              placeholder={"Please select style type"}
              contentType={saticStyle}
              handleContentChange={handleStyleData}
              name={"style"}
              id={"style-type2"}
            />
          </div>
        </div>
        <div className="flex justify-end my-4">
          <button
            onClick={addSegment}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Add Awards
          </button>
        </div>
        {versionData && versionData?.length > 0 && <p>Old data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Segments */}

          {versionData &&
            versionData?.segments?.map((award, index) => (
              <div key={index} className="py-4 xl:col-span-4">
                <AwardSegmentCard
                  key={index}
                  index={index}
                  award={award}
                  isEditable={false}
                  handleRemoveIcon={handleRemoveIcon}
                  toggle={toggle}
                  setIndex={setIndex}
                  setEventData={setEventData}
                  errors={errors}
                  handleSegmentInputChange={handleSegmentInputChange}
                  removeSegment={removeSegment}
                />
              </div>
            ))}
        </div>
        {segments && segments?.length > 0 && <p>New data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {segments?.map((award, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <AwardSegmentCard
                index={index}
                award={award}
                isEditable={true}
                handleRemoveIcon={handleRemoveIcon}
                toggle={toggle}
                setIndex={setIndex}
                setEventData={setEventData}
                errors={errors}
                handleSegmentInputChange={handleSegmentInputChange}
                removeSegment={removeSegment}
              />
            </div>
          ))}
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showVideo}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Icon"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <IconView
            showImage={showVideo}
            setEventData={setEventData}
            togleImage={toggle}
          />
        </Drawer.Body>
      </Drawer>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default AwardSegment;
